export default {
  hero: {
    title: 'AllChinaBuy Spreadsheet — Find Products, Sellers & Buying Resources',
    subtitle: 'Explore the AllChinaBuy spreadsheet, product resources, seller guides, QC information, shipping guides and practical buying tips in one place. Research smarter before you order.',
    ctaMain: 'Explore AllChinaBuy Spreadsheet',
    ctaSecondary: 'Start Beginner Guide',
    ctaAllChinaBuy: 'AllChinaBuy Spreadsheet',
    ctaBuyNow: 'Buy It Now',
  },
  categories: {
    title: 'Popular Categories',
    subtitle: 'Browse product categories and find exactly what you are looking for',
  },
  articles: {
    title: 'Latest Guides & Resources',
    subtitle: 'Original research, buying tips and practical guides to help you shop smarter',
  },
  features: {
    title: 'Why Use AllChinaBuy Spreadsheet?',
    item1: 'Organized product links from trusted sellers',
    item2: 'QC photos and quality verification tips',
    item3: 'Shipping cost estimates and method comparisons',
    item4: 'Active coupon and discount code updates',
  },
  seo: {
    title: 'AllChinaBuy Spreadsheet 2026 — Products, Sellers, QC & Shipping',
    description: 'Explore the AllChinaBuy spreadsheet, product resources, seller guides, QC information, shipping guides and practical buying tips in one place.',
    keywords: 'AllChinaBuy, spreadsheet, buying guide, shipping, QC, coupon, discount',
  },
};